import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import {
  DATE_FORMATS,
  isMessagingRevempEnabled,
} from "MessagingV2/modules/Utils";
import { connect } from "react-redux";
import { formatDate, getGlobalTimezone } from "Utils";

import classes from "./DateMessage.scss";

const DateMessage = props => {
  const { date } = props;
  const dateClasses = classNames(
    "text-subtitle-3",
    "text-textSubtle",
    classes.date
  );

  const dateClassesV2 = classNames("text-body-3", classes.dateV2);

  const formattedDate = formatDate({
    date,
    format: DATE_FORMATS.DATE_MESSAGE,
  });

  return isMessagingRevempEnabled() ? (
    <div className={classes.dateContainer}>
      <div className={classes.border} />
      <div className={dateClassesV2}>{formattedDate}</div>
      <div className={classes.border} />
    </div>
  ) : (
    <div className={dateClasses}>{formattedDate}</div>
  );
};

DateMessage.propTypes = {
  date: PropTypes.string.isRequired, // ISO date string
};

const mapStateToProps = () => ({
  currentTimezone: getGlobalTimezone(),
});

export default connect(mapStateToProps)(DateMessage);
